export class UTCHelper{
    static convertUTCDateToLocalDate(date: Date): Date | null {
        if(date == null || date == undefined)
          return null;
        const newDate = new Date(date.toString());
        if(isNaN(newDate.getTime()))
          return null;
        let localDate = new Date(newDate.getTime() + getClientTimeOffset());
        return localDate;
    }
    static parseNullsForStaticDates(date: Date): Date | null {
        if(date == null || date == undefined)
          {return null;}
        const newDate = new Date(date.toString());
        if(isNaN(newDate.getTime()))
          {return null;}
        return newDate;
    }
    static isValidDate(value: any): boolean {
      if(value === null)
      {return false;}
      return value === null || (value instanceof Date && !isNaN(value.getTime()));
  }
}
function getClientTimeOffset(): number {
    const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const serverTime = new Date(); // Use the current server time for the conversion
    const serverOffset = serverTime.getTimezoneOffset() * -1; // Get the server's time zone offset in minutes
    const clientOffset = Math.round(serverOffset / 15) * 15; // Round the client's time zone offset to the nearest 15-minute interval
    const clientTime = new Date(serverTime.getTime() + clientOffset * 60 * 1000); // Convert the server time to client time using the rounded client offset
  
    return clientTime.getTime() - (new Date()).getTime();
  }



  